export default "__VITE_ASSET__3516e029__"